<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 掲示板（コメント）の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>掲示板（コメント）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/board-comment.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> スレッド表示
        </div>
        <div class="manual-explain">
          スレッドが表示されます。<br>
          投稿者アイコンをクリックすることで閲覧画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> コメントボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          掲示板（コメント）一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、コメント
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 掲示板（コメント）一覧
        </div>
        <div class="manual-explain">
          登録済みの掲示板（コメント）の一覧が表示されます。<br>
          投稿者は、自身の投稿は青色のアイコン、他人の投稿は赤色のアイコンで表示されます。<br>
          投稿者アイコンをクリックすることで編集画面（自身の投稿）・閲覧画面（他人の投稿）が表示されます。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Bulletin Board (Comments) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Bulletin Board (Comments) Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_board-comment.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Thread Display
          </div>
          <div class="manual-explain">
            Threads are displayed.<br>
            Clicking on the poster's icon will show the view screen.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Comment Button
          </div>
          <div class="manual-explain">
            Clicking this button will open the add comment screen.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Filter
          </div>
          <div class="manual-explain">
            Filters the data displayed in the Bulletin Board (Comments) list.<br>
            *The filter applies to comments.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Bulletin Board (Comments) List
          </div>
          <div class="manual-explain">
            Displays a list of registered Bulletin Board (Comments).<br>
            For posts, the poster's own posts are shown with a blue icon, while others' posts are shown with a red icon.<br>
            Clicking on the poster's icon will open the edit screen (for own posts) or the view screen (for others' posts).
          </div>

        </mat-card-content>
      </mat-card>

  </div>

</div>